<template>
  <div class="toggle-container">
    <div class="toggle">
      <button
        :class="{'active': isBuyActive}"
        @click="toggle('buy')"
        class="toggle-button"
      >
        Buy
      </button>
      <button
        :class="{'active': !isBuyActive}"
        @click="toggle('rent')"
        class="toggle-button"
      >
        Rent
      </button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isBuyActive: true
    }
  },
  mounted() {
    this.$emit('toggleValue', 'sale')
  },
  methods: {
    toggle(option) {
      this.isBuyActive = option === 'buy'
      this.$emit('toggleValue', this.isBuyActive ? 'sale' : 'rental')
    }
  }
}
</script>

<style scoped>
.toggle-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: auto;
}

.toggle {
  display: flex;
  background: #C7C2BB;
  border-radius: 9px;
  padding: 1px;
}

.toggle-button {
  flex: 1;
  padding: 6px 14px;
  background-color: transparent;
  border: none;
  border-radius: 9px;
  cursor: pointer;
  transition: background-color 0.3s;
  font-weight: 500;
  color: #555555;
  font-size: 10px;
}

.toggle-button.active {
  background-color: white;
  color: black;
  box-shadow: 0 0 0 1px #C7C2BB;
  font-weight: 600;

}
</style>
